<template>
  <div class="chat-history-pagination">
    <div class="d-flex align-center justify-space-around">
      <v-icon @click="$emit('prevPage')" :disabled="page === 1">mdi-chevron-left</v-icon>
      <span class="text-center"> {{perPage * page > sessionsTotal ? sessionsTotal : perPage * page}}/ {{sessionsTotal}}</span>
      <v-icon @click="$emit('nextPage')" :disabled="page === totalPages">mdi-chevron-right</v-icon>
    </div>
  </div>
</template>

<script>
  export default {
    name: "sessionsPages",
    props: {
      sessionsTotal: {
        type: Number,
        default: ()=> {
          return 0
        }
      },
      page: {
        type: Number,
        default: ()=> {
          return 1
        }
      },
      perPage: {
        type: Number ,
        default: ()=> {
          return 50
        }
      }
    },
    computed: {
      totalPages () {
        return Math.ceil(this.sessionsTotal / this.perPage)
      }
    }
  }
</script>

<style scoped>

</style>
